export const getImgUrl = (img: string) => {
    return require('@/assets/' + img);
}